/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Venues_SearchInputs */

const cs_settings_venues_search = /** @type {(inputs: Settings_Venues_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hledat pobočky`)
};

const en_settings_venues_search = /** @type {(inputs: Settings_Venues_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search offices`)
};

/**
* | output |
* | --- |
* | "Search offices" |
*
* @param {Settings_Venues_SearchInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_venues_search = /** @type {((inputs?: Settings_Venues_SearchInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Venues_SearchInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_venues_search(inputs)
	return cs_settings_venues_search(inputs)
});